class TabPanel extends HTMLElement {
  connectedCallback() {
    this.setEventListeners()
  }

  setEventListeners() {
    this.tabEls.forEach(tabEl => {
      tabEl.addEventListener('click', this.handleTabClick.bind(this))
    })
  }

  handleTabClick(event) {
    const selectedTabEl = event.target;
    const selectedTabId = selectedTabEl.getAttribute('id');
    const selectedPanelEl = this.querySelector(`[aria-labelledby="${selectedTabId}"]`);

    this.tabEls.forEach(tabEl => {
      tabEl.setAttribute('aria-selected', 'false');
    })

    this.panelsEls.forEach(panelEl => {
      panelEl.setAttribute('hidden', null);
    })

    console.log('selectedTabId', selectedPanelEl)

    selectedTabEl.setAttribute('aria-selected', 'true');
    selectedPanelEl.removeAttribute('hidden');
  }


  get tabEls() {
    return this.querySelectorAll('[data-tab-panel-el="tab"]');
  }

  get panelsEls() {
    return this.querySelectorAll('[data-tab-panel-el="panel"]');
  }

  get richtext() {
    return this.querySelector('[data-tab-panel-el="richtext"]');
  }

}

customElements.define('tab-panel', TabPanel);
